module.exports = __webpack_public_path__ + "img/@logo_law_hm@3x.d52b21b0.png";